
const digest = 'ca1a5b65a84b99769480950f9b3a46377aa9944ad44a3f1ee4edab496702fe2b';
const css = `._commandMenuItem_14z45_1 {
  display: contents; /* Let the natural display of children (implicit in aha-menu-item) take over. */
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"commandMenuItem":"_commandMenuItem_14z45_1"};
export { css, digest };
  